import { loadEmblaCarousel } from '../util/load-dependencies';
import { enableNavButtons } from '../util/embla/util';
import SiteEvents, { SiteEventNames } from '../util/site-events';
import { getViewportSizeName } from '../util/general-util';

class PartnerOffers {
	constructor(el) {
		this.el = el;
		this.emblaRootEl = this.el.querySelector('.embla');
		this.btnPrevEl = this.el.querySelector('.partner-offers__nav-button--prev');
		this.btnNextEl = this.el.querySelector('.partner-offers__nav-button--next');
		this.paginationEl = this.el.querySelector('.block-media__pagination');
		this.emblaPagination = null;
		this.lastViewportSizeName = getViewportSizeName();
		this.slidesToScrollValues = { small: 1, medium: 2, large: 3 };

		this.transitionSpeed = this.emblaRootEl
			? parseInt(this.emblaRootEl.getAttribute('data-transition-speed') || 300, 10)
			: 300;

		this.emblaDefaultOpts = {
			// slidesToScroll: this.slidesToScrollValues[getViewportSizeName()],
			slidesToScroll: 1,
			skipSnaps: false,
			speed: this.transitionSpeed,
			loop: true,

			align: 'start'
		};
		this.emblaInstance = null;

		this.initEmbla();

		window.addEventListener('resize', () => {
			const viewportSizeName = getViewportSizeName();

			if (this.lastViewportSizeName !== viewportSizeName) {
				if (this.emblaInstance) {
					this.emblaInstance.reInit({
						...this.emblaDefaultOpts
						// slidesToScroll: this.slidesToScrollValues[getViewportSizeName()]
					});

					enableNavButtons(this.emblaInstance, this.btnPrevEl, this.btnNextEl);
				}

				this.lastViewportSizeName = viewportSizeName;
			}
		});
	}

	async initEmbla() {
		try {
			const EmblaCarousel = await loadEmblaCarousel();

			this.emblaInstance = EmblaCarousel(this.emblaRootEl, this.emblaDefaultOpts);

			if (!this.emblaInstance) {
				return;
			}

			this.emblaInstance.on('init', () => {
				SiteEvents.publish(SiteEventNames.IMAGEBUDDY_TRIGGER_UPDATE);
			});

			enableNavButtons(this.emblaInstance, this.btnPrevEl, this.btnNextEl);
		} catch (err) {
			console.error(err);
		}
	}
}

export default PartnerOffers;
